/**
 * Decode a `data:<mime>;base64,<payload>` URL into a typed Blob for upload.
 * Returns null on malformed input. Shared by the nameplate analyzer and the
 * rotation-check sync (both turn a stored base64 image into multipart bytes).
 */
export function dataUrlToBlob(dataUrl: string): Blob | null {
  const comma = dataUrl.indexOf(',');
  if (!dataUrl.startsWith('data:') || comma < 0) return null;
  const header = dataUrl.slice(0, comma);
  const data = dataUrl.slice(comma + 1);
  const mime = /^data:([^;,]+)/.exec(header)?.[1] || 'image/jpeg';
  const isBase64 = /;base64/i.test(header);
  try {
    if (isBase64) {
      const binary = atob(data);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
      return new Blob([bytes], { type: mime });
    }
    return new Blob([decodeURIComponent(data)], { type: mime });
  } catch {
    return null;
  }
}
